(() => {
  const rng = (seed) => () => { seed |= 0; seed = (seed + 0x6D2B79F5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  const spark = (dir, seed) => {
    const r = rng(seed * 7919 + (dir === 'up' ? 13 : 71));
    const n = 12; const pts = [];
    for (let k = 0; k < n; k++) {
      const t = k / (n - 1);
      const trend = dir === 'up' ? 35 - t * (24 + r() * 8) - Math.pow(t, 2) * 4 : 6 + t * (22 + r() * 8);
      const jag = (k % 2 ? 1 : -1) * (2 + r() * (dir === 'up' ? 3.5 : 5));
      pts.push([2 + t * 116, Math.max(2, Math.min(38, trend + (k && k < n - 1 ? jag : 0)))]);
    }
    return pts.map((p, k) => (k ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
  };
  const init = (root) => {
    const stage = root.querySelector('[data-leo-ba]');
    if (!stage || stage.dataset.ready) return;
    stage.dataset.ready = '1';
    const sec = stage.closest('section');
    let data = [];
    try { data = JSON.parse(sec.querySelector('[data-leo-ba-data]').textContent); } catch (e) { data = []; }
    const down = sec.querySelector('[data-ba-spark="down"]');
    const up = sec.querySelector('[data-ba-spark="up"]');
    const setSparks = (k) => { if (down) down.setAttribute('d', spark('down', k + 1)); if (up) up.setAttribute('d', spark('up', k + 1)); };
    const n = data.length;
    if (n < 2) return;
    setSparks(0);
    const dots = [...sec.querySelectorAll('.leo-ba__dots i')];
    const vals = [...sec.querySelectorAll('[data-ba-v]')];
    const ms = Math.max(1000, (parseFloat(stage.dataset.interval) || 5) * 1000);
    let i = 0; let elapsed = 0; let last = 0; let raf = 0; let visible = false;
    const paintDots = () => dots.forEach((d, j) => {
      d.classList.toggle('is-done', j < i);
      d.firstElementChild.style.width = j === i ? Math.min(100, (elapsed / ms) * 100) + '%' : (j < i ? '100%' : '0%');
    });
    const go = (k) => {
      i = (k + n) % n; elapsed = 0;
      stage.querySelectorAll('[data-leo-ba-slide]').forEach((img) => img.classList.toggle('is-on', +img.dataset.leoBaSlide === i));
      sec.classList.add('is-swap');
      setTimeout(() => { vals.forEach((v) => { v.textContent = data[i][v.dataset.baV] || ''; }); setSparks(i); sec.classList.remove('is-swap'); }, 250);
      paintDots();
    };
    const tick = (ts) => {
      if (!last) last = ts;
      elapsed += ts - last; last = ts;
      if (elapsed >= ms) go(i + 1); else paintDots();
      raf = requestAnimationFrame(tick);
    };
    const run = () => { if (raf || !visible || document.hidden) return; last = 0; raf = requestAnimationFrame(tick); };
    const halt = () => { cancelAnimationFrame(raf); raf = 0; };
    new IntersectionObserver((en) => en.forEach((e) => { visible = e.isIntersecting; visible ? run() : halt(); }), { threshold: 0.2 }).observe(stage);
    document.addEventListener('visibilitychange', () => (document.hidden ? halt() : run()));
    dots.forEach((d, j) => { d.style.cursor = 'pointer'; d.addEventListener('click', () => go(j)); });
    paintDots();
  };
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();